/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {completeDigitalWalletTokenProvisioning} from '../api'

export const useMutationCompleteDigitalWalletTokenProvisioning = createReactQueryMutationHook('completeDigitalWalletTokenProvisioning', completeDigitalWalletTokenProvisioning)
